import { render } from "./productGroupOverview.vue?vue&type=template&id=efb96cda"
import script from "./productGroupOverview.vue?vue&type=script&lang=js"
export * from "./productGroupOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__